<script>
import { Typeahead } from "uiv";
import { mapGetters } from "vuex";
import Placeholder from "../Placeholder/Filtros/Texto.vue";

export default {
  components: { Placeholder, Typeahead },
  computed: {
    ...mapGetters(["isMaster", "getFiltroNombreSugerido"])
  },
  data() {
    return {
      filtro: this.$store.getters.getFiltroNombre
    };
  },
  watch: {
    filtro(payload) {
      this.$store.commit("setFiltroNombre", payload);
    }
  },
  methods: {
    clear() {
      if (this.filtro.length) {
        this.filtro = "";
      }
    }
  }
};
</script>

<template>
  <div>
    <div v-if="isMaster" id="filtro_nombre">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="filtro_nombre_input"
          placeholder="Filtrar por Nombre"
          v-model="filtro"
        />
        <div class="input-group-btn">
          <button class="btn btn-default" type="button" @click="clear">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
      <typeahead v-model="filtro" :data="getFiltroNombreSugerido" target="#filtro_nombre_input" />
    </div>
    <placeholder v-else></placeholder>
  </div>
</template>

<style lang="scss" scoped>
#filtro_nombre {
  margin-bottom: 20px;

  .input-group {
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);

    > .form-control {
      border: 0;
      padding: 6px 0px 6px 6px;
      box-shadow: none;
      font-style: normal;
      background: #fff;

      &:focus {
        background: rgba(255, 255, 255, 0.8);
      }
    }

    > .input-group-btn > .btn {
      border-color: #fff;
    }
  }

  > .dropdown > .dropdown-menu {
    border: 0;
    margin: 0;
    padding: 0;
    overflow: hidden;
    box-shadow: 0 10px 8px rgba(0, 0, 0, 0.175);
    border-top-left-radius: 0;
  }
}
</style>